import { Spin as AntdSpin } from "antd";
import type { SpinProps } from "antd/lib/spin";
import type { FC } from "react";

import Progress from "./icons";

const Spin: FC<SpinProps> = ({
	children,
	className = "",
	wrapperClassName = "",
	tip = "Загрузка...",
	...props
}) => {
	return (
		<AntdSpin
			className={`customSpin ${className}`}
			wrapperClassName={`customSpinWrapper ${wrapperClassName}`}
			tip={children ? tip : ""}
			indicator={<Progress />}
			delay={100}
			{...props}
		>
			{children}
		</AntdSpin>
	);
};

export default Spin;
